import React from 'react';

const WrongSymbol = () => {
	return (
		<>
			<div className="wrong-symbol">&#10007;</div>
		</>
	);
};

export default WrongSymbol;
